import React from 'react';
import Layout from '../components/Layout';
import {Link} from 'gatsby';
import Nod from '../components/nod';

export default function Home() {

  const pages = [
    {
      label: 'SASTRERÍA DESESTRUCTURADA',
      path: '/sastreria/'
    },
    {
      label: 'THE COVEN — LOOK BOOK',
      path: "/lookbook/"
    },
    {
      label: 'BACK TO BLACK',
      path: "/backtoblack/"
    },
    {
      label: 'BOLUMINISCENCIA',
      path: '/boluminiscencia/'
    },
  ];

  const letters = "NÉSTOR OSUNA".split("");

  return <Layout hideNavigation>
    <Nod title={"Portfolio"}/>
    <div className="home">
      <header className="home-header">
        <div className="home-brand">
          <img className="home-logo" alt="Néstor Osuna" src={require('/src/images/logoNestor.png').default} />
          <div className="home-lettering">
            {letters.map((l, i) => (
              <span key={i} className="home-letter">{l === " " ? "\u00A0" : l}</span>
            ))}
          </div>
        </div>
      </header>

      <nav className="home-nav">
        <ul className="home-list">
          {pages.map(({label, path}, i) => (
            <li key={path} className="home-list-item">
              <Link to={path} className="home-list-link">
                <span className="home-list-index">{(i + 1).toString().padStart(2, '0')}</span>
                <span className="home-list-label">{label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <footer className="home-footer">
        <Link className="home-about" to={'/about'}>About</Link>
      </footer>
    </div>
  </Layout>;
}
